import { useIntl } from 'react-intl';

import { getRecordingAssetEpisodeIndication, RecordingAsset } from '@kaltura-ott/tvpil-shared';

import { getSeasonEpisodeTitleV2 } from 'utils';

export function useEpisodeTitle(recording: RecordingAsset) {
  const intl = useIntl();

  const seasonEpisodeMeta = getRecordingAssetEpisodeIndication(recording);

  return getSeasonEpisodeTitleV2(intl, seasonEpisodeMeta, ':', true);
}
